export default {
  customType: state => state.customType,
  contactsType: state => state.contactsType,
  visitType: state => state.visitType,
  crmAuth: state => state.crmAuth,
  clerkList: state => state.clerkList,
  signinTeams: state => state.signinTeams,
  productList: state => state.productList,
  productListLoading: state => state.productListLoading,
  userList: state => state.userList,
  userAdmins: state => state.userAdmins,
  hospitalLevel: state => state.hospitalLevel,
  doctorTitle: state => state.doctorTitle,
  homeAuditiongApllyLists: state => state.homeAuditiongApllyList,
  customLists: state => state.customList,
  serviceLines: state => state.serviceLines,
  userTeamId: state => state.userTeamId,
  serviceType: state => state.serviceType,
  clueSource: state => state.clueSource,
  invalidReason: state => state.invalidReason,
  investigationNature: state => state.investigationNature,
  investigatType: state => state.investigatType,
  receptionLevel: state => state.receptionLevel,
  projectStage: state => state.projectStage,
  modeTypeList: state => state.modeTypeList,
  settlementList: state => state.settlementList,
  customLevelList: state => state.customLevelList,
};
